/**
 * ChangePin —— **首次登入強制改 PIN**（`create-user --temp` 建嘅用戶）
 * 要輸入：現有 PIN（＝臨時 PIN）＋ 新 PIN（≥6 字元，唔准弱碼）＋ 確認。
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api';

export default function ChangePin({ onDone, onLogout }: { onDone: () => void; onLogout?: () => void }) {
  const { t } = useTranslation();
  const [currentPin, setCurrentPin] = useState('');
  const [newPin, setNewPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    if (newPin !== confirmPin) { setErr(t('changepin.mismatch')); return; }
    setBusy(true);
    try {
      await api.changePin(currentPin, newPin);
      onDone();
    } catch (ex) {
      setErr(ex instanceof Error ? ex.message : String(ex));
    } finally { setBusy(false); }
  };

  return (
    <main className="page">
      <h1 className="title">{t('app.title')}</h1>
      <form className="card" onSubmit={submit}>
        <h2>{t('changepin.heading')}</h2>
        <p className="note">{t('changepin.note')}</p>
        <label className="field">
          <span>{t('changepin.current')}</span>
          <input type="password" autoComplete="current-password" value={currentPin}
            onChange={(e) => setCurrentPin(e.target.value)} required />
        </label>
        <label className="field">
          <span>{t('changepin.new')}</span>
          <input type="password" autoComplete="new-password" value={newPin}
            onChange={(e) => setNewPin(e.target.value)} required />
        </label>
        <label className="field">
          <span>{t('changepin.confirm')}</span>
          <input type="password" autoComplete="new-password" value={confirmPin}
            onChange={(e) => setConfirmPin(e.target.value)} required />
        </label>
        {err && <p className="err">{err}</p>}
        <button className="cta" type="submit" disabled={busy}>{busy ? t('changepin.saving') : t('changepin.save')}</button>
        {onLogout && <button type="button" className="cta secondary" onClick={onLogout}>{t('auth.sign_out')}</button>}
      </form>
    </main>
  );
}
